import React, { Component, PropTypes } from 'react'
import { connect } from 'react-redux'

import { setNewVenue, updateNewVenue } from 'actions/setupform'
import { getNewVenue, getNewVenueOriginal } from 'selectors/setupform'
import { extractVenue } from 'utils/geosuggest'

import VenueSearchGoogle from './venue-search-google'

export class VenueSearchGoogleContainer extends Component {

  constructor(props) {
    super(props)
    this.handleFieldUpdate = this.handleFieldUpdate.bind(this)
    this.handleClear = this.handleClear.bind(this)
    this.handleSelectVenueSuggestion = this.handleSelectVenueSuggestion.bind(this)
  }

  handleFieldUpdate(field) {
    return (event) => {
      this.props.updateNewVenue({ [field]: event.target.value })
    }
  }

  handleClear() {
    this.props.setNewVenue(null)
  }

  handleSelectVenueSuggestion(suggestion) {
    const venue = extractVenue(suggestion)
    this.props.setNewVenue(venue)
  }

  render() {
    return (
      <VenueSearchGoogle
        {...this.props}
        handleClear={this.handleClear}
        handleFieldUpdate={this.handleFieldUpdate}
        handleSelectVenueSuggestion={this.handleSelectVenueSuggestion}
      />
    )
  }
}

VenueSearchGoogleContainer.propTypes = {
  handleUpdateNewVenue: PropTypes.func,
  setNewVenue: PropTypes.func,
  updateNewVenue: PropTypes.func,
}

const mapStateToProps = state => ({
  newVenue: getNewVenue(state),
  newVenueOriginal: getNewVenueOriginal(state),
})

const mapDispatchToProps = { setNewVenue, updateNewVenue }

export default connect(mapStateToProps, mapDispatchToProps)(VenueSearchGoogleContainer)



/** WEBPACK FOOTER **
 ** ./src/components/setupform-form/field/venue-search/venue-search-google/venue-search-google-container.js
 **/